module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "bio",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fatema Alaali graduated with a bachelor’s degree in Banking and Finance. She is currently taking her master’s degree in Education. She aims to make the world a better place.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/cover.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CP-H"
  }, [_vm._v("Copyright © Fatema Alaali 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fatema Alaali")]), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to be identified as author of this work has been asserted by the author in accordance with Federal Law No. (7) of UAE, Year 2002, Concerning Copyrights and Neighboring Rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to legal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The age group that matches the content of the books has been classified according to the age classification system issued by the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ministry of Culture and Youth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN – 9789948751526 – (Paperback)"), _c('br'), _vm._v("ISBN – 9789948751533 – (E-Book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Application Number:  MC-10-01-4661156"), _c('br'), _vm._v("Age Classification: E")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("First Published 2024"), _c('br'), _vm._v("AUSTIN MACAULEY PUBLISHERS FZE"), _c('br'), _vm._v("Sharjah Publishing City"), _c('br'), _vm._v("P.O. Box [519201]"), _c('br'), _vm._v("Sharjah, UAE"), _c('br'), _vm._v("www.austinmacauley.ae"), _c('br'), _vm._v("+971 655 95 202")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt7.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt9.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt10.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt11.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt12.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt32.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt34.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt36.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9789948751526_txt38.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf04519","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9789948751526_EPUB.vue
// module id = 57
// module chunks = 0